module.exports = __webpack_public_path__ + "96223a075bbd22d7eb69b80ec341174b.ttf";